import { render, staticRenderFns } from "./EmbedderCodeManagementModal.vue?vue&type=template&id=0ed07696&scoped=true&"
import script from "./EmbedderCodeManagementModal.vue?vue&type=script&lang=js&"
export * from "./EmbedderCodeManagementModal.vue?vue&type=script&lang=js&"
import style0 from "./EmbedderCodeManagementModal.vue?vue&type=style&index=0&id=0ed07696&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed07696",
  null
  
)

export default component.exports